import styled from 'styled-components';

export const ItemContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

export const ItemIcon = styled.div`
  background-color: ${({ bg }) => bg};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ItemAmount = styled.div`
  font: normal normal bold 24px/20px Geist;
  color: #6d6b7b;
`;

export const ItemTitle = styled.div`
  font: normal normal medium 14px/20px Geist;
  color: #6d6b7b;
`;
